var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgX(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.5304 2.53044L19.0608 2.00011L18.0001 0.939453L17.4698 1.46978L10.0001 8.93945L2.53044 1.46978L2.00011 0.939453L0.939453 2.00011L1.46978 2.53044L8.93945 10.0001L1.46978 17.4698L0.939453 18.0001L2.00011 19.0608L2.53044 18.5304L10.0001 11.0608L17.4698 18.5304L18.0001 19.0608L19.0608 18.0001L18.5304 17.4698L11.0608 10.0001L18.5304 2.53044Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgX);
export default __webpack_public_path__ + "static/media/X.6c5fff719a3f466b551575dd966f135d.svg";
export { ForwardRef as ReactComponent };